import useQrHardwareControllerState from './useQrHardwareControllerState'

export default useQrHardwareControllerState
